import React, { useEffect, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import "react-day-picker/style.css";
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { store } from '../../services/service';
import { useStoreSurvey } from '../../store/SurveyStore';
import { MODIFIER_RENDEZ_VOUS, SURVEY_PAR_TYPE } from '../../Utils/constant';
import { SubmitButton } from '../Widget/SubmitButton';

export const UpdateRdv = ({ item }) => {
    const [selected, setSelected] = useState(null);
    const survey = useStoreSurvey()
    const [error, setError] = useState(null)
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);

    const submit = (data) => {
        if (selected) {
            setIsSubmit(true)
            store(`${MODIFIER_RENDEZ_VOUS}/${item?.id}`, "application/json", {
                ...data, dateRdv: selected?.toLocaleDateString("es-CL")
            }).then((res) => {
                survey.getData(`${SURVEY_PAR_TYPE}?page=0&param=&size=8&periode=&mois=&annee=&dateDebut=&dateFin=&status=EN_ATTENTE&resultat=&typeRdv=SURVEY`)
                setIsSubmit(false);
                reset();
                document.getElementById('editrdv').close()
                toast.success('Mis à jour effectuée')
            }).catch((err) => {
                setIsSubmit(false)
                setError(err?.response?.data?.donnee)
            })
        } else {
            setError('Selectionnez une date svp !')
        }

    }

    useEffect(() => {
        if (item) {
            reset();
        }
    }, [item, reset]);

    return (
        <form onSubmit={handleSubmit(submit)} className=''>
            <p className='text-red-500 text-xs my-2'>{error}</p>
            <DayPicker
                mode="single"
                selected={selected}
                onSelect={setSelected}
            />
            <div className='my-2'>
                <label htmlFor="" className='text-sm font-medium'>Commentaire</label>
                <textarea {...register('commentaire')} className='textarea textarea-bordered w-full'></textarea>
            </div>
            <SubmitButton label={"Enregistrer"} isSubmit={isSubmit} />
        </form>
    )
}
